module.exports = __webpack_public_path__ + "plot-generator/static/media/balls.61eb5abc.svg";